import { QueryKeys } from '../../../queryDefaults/QueryKeys.ts';
import { useHighFrequencyRefreshQuery } from '../../../queryDefaults/baseQueries/useHighFrequencyRefreshQuery.tsx';
import { IPatientProfiles, PatientProfiles } from '../Patient.ts';
import { PatientsApi } from '../../../apis/PatientsApi/PatientsApi.ts';
import { useSessionProvider } from '../../../provider/sessionContext.tsx';

export function useGetPatientsProfile() {
    const { currentUser } = useSessionProvider();
    const isPatient = !!currentUser?.patientID;

    return useHighFrequencyRefreshQuery({
        queryKey: [QueryKeys.patientProfiles],
        queryFn: async () => {
            const result: IPatientProfiles = await PatientsApi.getPatientsProfiles();
            return new PatientProfiles(result);
        },
        enabled: !!currentUser && isPatient,
    });
}
